import styles from "./IDCell.module.scss"
import { IDCellProps } from "./IDCell.types"

export default function IDCell(props: IDCellProps) {
    const { id } = props
    return <div className={styles.base}>{id}</div>
}
